import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CsiteSupplier } from '@arpada/arp-lib-common-qupro';

@Component({
  selector: 'app-csite',
  templateUrl: './csite.component.html',
  styleUrls: ['./csite.component.scss'],
})
export class CsiteComponent implements OnInit {

  @Input() csite: CsiteSupplier;

  constructor(private router: Router) { }

  ngOnInit() {}

  ver(csite: CsiteSupplier) {
    this.router.navigate(['main', 'inci-postventa', csite.id]);
  }

}
